// export interface XValues {
//     hourly: string[];
//     daily: string[];
//     weekly: string[];
//     monthly: string[];
//     quarterly: string[];
// }
// export interface YValues {
//     hourly: number[];
//     daily: number[];
//     weekly: number[];
//     monthly: number[];
//     quarterly: number[];
// }
export const chartView = {
    fullView: false,
    plot: "daily",
    plugins: {
        tooltip: {
            titleColor: 'black',
            backgroundColor: 'white',
            bodyColor: 'black',
            borderColor: 'black',
            borderWidth: 0.1,
        },
        legend: {
            display: false,
        },
    },
    scales: {
        xAxis: {
            // position: 'bottom',
            title: {
                display: true,
                text: 'Request week (start date)',
                padding: 0,
                font: {
                    weight: 'lighter',
                    size: 12
                }
            },
            ticks: {
                crossAlign: 'center',
                color: 'rgba(0, 0, 0, 0.5)',
                font: {
                    size: 12,
                },
                display: true,
                padding: 20,
                autoSkip: false,
                maxRotation: 90,
                minRotation: 90,
            },
            grid: { drawTicks: false, color: 'rgba(0, 0, 0, 0.05)' },
            border: { color: 'rgba(0, 0, 0, 0.025)' },
        },
        yAxis: {
            min: -100,
            max: 100,
            title: {
                display: true,
                text: 'NPS',
                padding: 0,
                font: {
                    weight: 'lighter',
                    size: 12
                }
            },
            ticks: {
                color: 'rgba(0, 0, 0, 0.5)',
                // postion: 'right',
                font: {
                    size: 12,
                },
                display: true,
                stepSize: 20,
                padding: 10
            },
            grid: { drawTicks: false, color: 'rgba(0, 0, 0, 0.05)' },
            border: { color: 'rgba(0, 0, 0, 0.025)' },
        },
    },
    // xValues: {
    //     hourly: ['00', '02', '04', '06', '08', '10', '12', '14', '16', '18', '20', '22', '24',],
    //     daily: ['MAR 01', 'MAR 02', 'MAR 03', 'MAR 04', 'MAR 05', 'MAR 06', 'MAR 07', 'MAR 08', 'MAR 09', 'MAR 10', 'MAR 11', 'MAR 12', 'MAR 13', 'MAR 14', 'MAR 15',],
    //     weekly: ['2 JAN 23', '16 JAN 23', '30 JAN 23', '13 FEB 23', '27 FEB 23', '13 MAR 23', '27 MAR 23', '10 APR 23', '24 APR 23', '8 MAY 23', '22 MAY 23', '5 JUN 23', '19 JUN 23', '3 JUL 23', '17 JUL 23', '31 JUL 23', '14 AUG 23', '28 AUG 23', '11 SEP 23', '25 SEP 23', '9 OCT 23', '23 OCT 23', '6 NOV 23', '20 NOV 23', '4 DEC 23', '18 DEC 23',],
    //     monthly: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',],
    //     quarterly: ['JAN - MAR', 'APR - JUN', 'JUL - SEP', 'OCT - DEC'],
    // },
    // yValues: {
    //     hourly: [44, 76, 30, 55, -50, -27, 10, 15, 34, 50, 75, 92, 60],
    //     daily: [60, 44, 76, 30, 55, 27, -50, -27, 10, 15, 34, 50, 62, 75, 92],
    //     weekly: [26, 60, 67, 44, 67, 76, 30, 44, 55, -67, 18, 27, -50, 78, 25, -27, 10, 78, 54, 90, 15, 34, 50, 62, 75, 92,],
    //     monthly: [-10, 27, 98, 84, 56, 36, -65, 82, 91, 35, 81, 95],
    //     quarterly: [85, -45, -27, 78],
    // },
};
export const barView = {
    fullView: false,
    scales: {
        x: {
            stacked: true,
            offset: true,
            ticks: {
                crossAlign: 'center',
                color: "rgba(0, 0, 0, 0.5)",
                font: {
                    size: 12,
                },
                display: true,
                padding: 20,
                autoSkip: false,
                maxRotation: 90,
                minRotation: 90,
            },
            grid: { display: true, drawTicks: false, offset: false },
            border: { color: "rgba(0, 0, 0, 0.025)" },
        },
        y: {
            stacked: true,
            min: 0,
            max: 50,
            title: {
                display: true,
                text: 'RESPONSE COUNT',
                padding: 0,
                font: {
                    weight: 'lighter'
                }
            },
            ticks: {
                color: "rgba(0, 0, 0, 0.5)",
                font: {
                    size: 12,
                },
                display: true,
                padding: 10,
                stepSize: 5,
            },
            grid: { drawTicks: false, color: "rgba(0, 0, 0, 0.05)" },
            border: { display: false },
        },
    },
};
export const GroupBarView = {
    type: 'bar',
    fullView: false,
    scales: {
        x: {
            stacked: false,
            offset: true,
            ticks: {
                crossAlign: 'center',
                color: "rgba(0, 0, 0, 0.5)",
                font: {
                    size: 12,
                },
                display: true,
                padding: 10,
                autoSkip: false,
                maxRotation: 90,
                minRotation: 90,
            },
            title:{
                display: true,
                text: 'Request Date',
                padding: 0,
                font:{
                    weight: 'lighter',
                    size: '12px',
                }
            },
            grid: { display: true, drawTicks: false, offset: false },
            border: { color: "rgba(0, 0, 0, 0.025)" },
        },
        y: {
            stacked: false,
            min: 0,
            
            title: {
                display: true,
                text: 'COUNT',
                padding: 0,
                font: {
                    weight: 'lighter'
                }
            },
            ticks: {
                beginAtZero: true,
                color: "rgba(0, 0, 0, 0.5)",
                font: {
                    size: 12,
                },
                display: true,
                padding: 10,
                stepSize: 5,
            },
            grid: { drawTicks: false, color: "rgba(0, 0, 0, 0.05)" },
            border: { display: false },
        },
    },
};

export const calendar = {
    months: [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
    ],
    monthsShort: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ],
    weeks: ["S", "M", "T", "W", "T", "F", "S"],
    focusedIndex: 2,
    startDate: '',
    endDate: '',
}